import React, { useState, useEffect, Fragment } from "react";
import { useParams } from "react-router-dom";
import URL from "../../../constant/URL";
import http from "../../../http/http";
import ConceptCheckPlayer from "../../common/ConceptCheckPlayer";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";

const AiPrediction = () => {

  const locale = localStorage.getItem( 'locale' );

  const [ data, setData ] = useState( {} );
  const [ isShowConceptCheckPlayer, setIsShowConceptCheckPlayer ] = useState( false );

  const params = useParams();

  useEffect( () => {
    http.request( {
      url : `${ URL.API.QSTISP.I }/language/${ locale }/stage/${ params.stageCode }/question`,
      success : setData
    } );
  }, [] );

  const showConceptCheckPlayer = () => {
    setIsShowConceptCheckPlayer( true );
  };

  const hideConceptCheckPlayer = () => {
    setIsShowConceptCheckPlayer( false );
  };

  return (
    <Fragment>
      <div className="layout-def layout-lc layout-lc-intro">
        <Header />
        <Body data={ data } />
        <Footer onShowConceptCheckPlayer={ showConceptCheckPlayer } />
      </div>
      { isShowConceptCheckPlayer && <ConceptCheckPlayer title={ data.stgNm } url={ data.cncpMeta } onHide={ hideConceptCheckPlayer } /> }
    </Fragment>
  );

};

export default AiPrediction;
